module.exports = __webpack_public_path__ + "files/REASINK.610dd1d70d866b91836db16e1415172e.zip";